import { render, staticRenderFns } from "./fromBuilding.vue?vue&type=template&id=e0fd0fa4"
import script from "./fromBuilding.vue?vue&type=script&lang=js"
export * from "./fromBuilding.vue?vue&type=script&lang=js"
import style0 from "./fromBuilding.vue?vue&type=style&index=0&id=e0fd0fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports